// Whether the page runs as the installed app (DESIGN 6.11). Its own module, so the tiny browser entry that decides about
// the landing section can ask without loading the rest of the platform module.

/** True when the app runs as an installed PWA (not merely a browser tab in fullscreen for a match). */
export function isStandalone(): boolean {
  if (typeof matchMedia !== 'function') return false;
  const iosStandalone = (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return (
    iosStandalone ||
    matchMedia('(display-mode: standalone)').matches ||
    (matchMedia('(display-mode: fullscreen)').matches && document.fullscreenElement === null)
  );
}
